import { Button } from '@mui/material';

export interface SignInButtonProps {
  /** The authentication provider login URL. Defaults to Azure AD EasyAuth. */
  loginUrl?: string;
  /** Button text content */
  children?: React.ReactNode;
  /** Button variant */
  variant?: 'text' | 'outlined' | 'contained';
  /** Button color */
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  /** Button size */
  size?: 'small' | 'medium' | 'large';
  /** Whether button is disabled */
  disabled?: boolean;
}

/**
 * A reusable sign-in button that redirects to the authentication provider.
 * Uses EasyAuth by default for Azure AD authentication.
 */
export function SignInButton({ 
  loginUrl = '/.auth/login/aad', 
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disabled = false
}: SignInButtonProps) {
  return (
    <Button
      component="a"
      href={loginUrl}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled}
    >
      {children || 'Sign in with your work account'}
    </Button>
  );
}
